import classNames from "classnames"

import FaqItem from "./FaqItem"
import { Color } from "../../../constants/V2/color"
import TextButton from "../../elements/V2/Buttons/TextButton"
import Grid from "../../elements/V2/Grid"
import ArrowIcon from "../../elements/V2/Icons/ArrowIcon"
import Section from "../../elements/V2/Section"
import Typography from "../../elements/V2/Typography"
import LayoutItem from "../Layouts/LayoutItem"

import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"
import React from "react"

type ItemProps = {
  question: string
  answerText: Storyblok.StoryblokRichtextContent
}

type FaqProps = {
  id?: string
  title: string
  body?: string
  linkText?: string
  linkUrl: string | YocoCom.YocoLink | undefined
  linkColor?: Color
  backgroundColor?: Color
  items: ItemProps[]
  superscript?: string
}

const Faq = ({
  id,
  title,
  body,
  linkText,
  linkUrl,
  linkColor = Color.Blue,
  items,
  backgroundColor = Color.Charcoal,
  superscript,
}: FaqProps) => {
  const textColor = getAccentColor(backgroundColor)

  return (
    <Section
      id={id}
      className={classNames(
        "-mb-lg py-3xl rounded-t-lg relative",
        getBackgroundColorClass(backgroundColor)
      )}
    >
      <Grid>
        <LayoutItem
          as="div"
          animateOnScroll
          className="col-span-4 flex flex-col gap-16 sm:col-span-2 md:col-span-3 md:gap-24 md:px-32 lg:col-span-6 lg:gap-32 lg:px-24"
        >
          {superscript && (
            <Typography
              font="grotesk"
              weight="book"
              color={textColor}
              size="body-md"
              text={superscript}
            />
          )}
          <Typography
            font="grotesk"
            weight="medium"
            color={textColor}
            size="h1"
            element="h2"
            text={title}
          />
          {body && (
            <Typography
              font="grotesk"
              weight="book"
              color={textColor}
              size="body-lg"
              text={body}
              className="mb-16 md:mb-24 lg:mb-32"
            />
          )}
          {linkText && linkUrl && (
            <TextButton
              text={linkText}
              linkUrl={linkUrl}
              color={linkColor}
              style="icon"
              icon={<ArrowIcon />}
              className="mb-8"
            />
          )}
        </LayoutItem>
        <LayoutItem
          as="div"
          animateOnScroll
          className="col-span-4 flex flex-col gap-24 sm:col-span-2 md:col-span-3 md:gap-32 lg:col-span-6 lg:gap-32"
        >
          {items.map(({ question, answerText }, index) => (
            <FaqItem
              key={`accordion-${question}-${index}`}
              question={question}
              answerText={answerText}
              linkColor={linkColor}
              textColor={textColor}
            />
          ))}
        </LayoutItem>
      </Grid>
    </Section>
  )
}

export default Faq
